import { Divider, Grid, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useProgramStats } from '@cibo/programs'

import { Loading } from '@cibo/profile'
import { FriendlyError } from '@cibo/ui'
import { ProgramsOrgStats } from 'pages/Home/ProgramsStats'
import { ProgramOpportunity } from 'pages/ProgramOpportunity'

export const OrganizationPrograms = () => {
  const { t } = useTranslation('impact/pages/OrganizationDetail')
  const { organizationId: orgId = '' } = useParams()
  const { data: orgStats, isFetching } = useProgramStats({
    orgId,
  })
  return (
    <Stack spacing={2} divider={<Divider />}>
      <Stack spacing={2}>
        <Typography variant="h6">{t('enrolled')}</Typography>
        {orgStats?.enrolledProgramsList && orgStats?.enrolledProgramsList.length > 0 ? (
          <Grid container spacing={2}>
            <Grid item container sm={12} md={8} spacing={2}>
              {orgStats?.enrolledProgramsList &&
                orgStats.enrolledProgramsList.map(programId => {
                  return (
                    <Grid key={programId} md={12} lg={6} item>
                      <ProgramOpportunity
                        programId={programId}
                        orgId={orgId}
                        hideBanner
                        hideOpportunities
                      />
                    </Grid>
                  )
                })}
            </Grid>
            <Grid item md={0} lg={1} />
            <Grid item sm={12} md={3} lg={3}>
              <ProgramsOrgStats orgId={orgId} />
            </Grid>
          </Grid>
        ) : isFetching ? (
          <Loading />
        ) : (
          <FriendlyError type="info" message={t('noEnrolledFields')} />
        )}
      </Stack>
      <Stack spacing={2}>
        <Typography variant="h6">{t('allPrograms')}</Typography>
        <Grid container spacing={2}>
          <Grid item container sm={12} spacing={2}>
            {orgStats &&
              orgStats.programs.map(({ programId }) => {
                return orgStats?.enrolledProgramsList &&
                  !!orgStats?.enrolledProgramsList.includes(programId) ? null : (
                  <Grid key={programId} md={6} lg={4} item>
                    <ProgramOpportunity programId={programId} orgId={orgId} hideBanner />
                  </Grid>
                )
              })}
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  )
}
